import type { FunctionComponent } from 'react';
import { lazy, Suspense } from 'react';

import { useBetSlice } from '../../store/slices/bets/selectors';
import { useChipSlice } from '../../store/slices/chips/selectors';
import { useConfigSlice } from '../../store/slices/config/selectors';
import { useGameStateSlice } from '../../store/slices/game/selectors';
import { useSettingsSlice } from '../../store/slices/settings/selectors';
import { ErrorBoundary } from '../errorBoundary/ErrorBoundary';

interface PromotionSelectorProps {
  drawBasedOn?: HTMLElement | null;
}

const PromotionsV2Root = lazy(() => import('./PromotionsRoot'));

export const PromotionSelector: FunctionComponent<PromotionSelectorProps> = ({ drawBasedOn }) => {
  const env = useConfigSlice.env();
  const userId = useConfigSlice.userId();
  const gameId = useConfigSlice.tableConfig()?.operatorGameId;
  const lang = useSettingsSlice.currentLanguage();
  const player = useConfigSlice.playerConfig();
  const jsessionId = useConfigSlice.JSESSIONID();
  const gsAddress = useConfigSlice.baseUrl();
  const currency = useGameStateSlice.userInfo()?.balance.currency;
  const casinoConfig = useConfigSlice.casinoConfig();
  const isBetOpenStatus = useGameStateSlice.isBetsOpenStatus();
  const totalBet = useBetSlice.totalBet();
  const remainingChips = useChipSlice.getFreeChipsRemaining();

  return (
    <ErrorBoundary fallback={null}>
      <Suspense>
        <PromotionsV2Root
          userId={userId ?? undefined}
          gameId={gameId}
          lang={lang}
          currency={currency}
          screenName={player?.screenName}
          casinoRegion={casinoConfig?.casinoRegion}
          envPromo={env?.promoService}
          envBonusPromo={env?.bonusPromotionsService}
          jwtToken={player?.jwtToken}
          envGs={gsAddress ?? undefined}
          jsessionId={jsessionId ?? undefined}
          isBetOpenStatus={isBetOpenStatus}
          totalBet={totalBet}
          drawBasedOn={drawBasedOn}
          remainingChips={remainingChips}
        />
      </Suspense>
    </ErrorBoundary>
  );
};
